var _ = require('lodash')
var config = require('./config-default.js')

_.extend(config, require('environment_config'))

module.exports = config
